module.exports = __webpack_public_path__ + "static/media/carry03.99105d47.png";